import { DivConst } from 'constants/divConst';
import { getDivLabel } from 'utils/app';

import type { JSX } from 'react';

/**
 * クイズステータス表示コンポーネント
 */
export default function QuizStatusBadge(props: {
  quizStatusDiv: number | null;
  size?: 'normal' | 'large';
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  const getClassColor = (): string => {
    // 稼働
    if (DivConst.items.quizStatus.published.value === props.quizStatusDiv) {
      return 'quiz-status-published';
    }
    // 稼働（予約）
    else if (DivConst.items.quizStatus.reserved.value === props.quizStatusDiv) {
      return 'quiz-status-reserved';
    }
    // 未稼働
    return 'quiz-status-unpublished';
  };

  const getClassSize = (): string => {
    if (props.size === 'large') {
      return 'badge-common-lg ';
    }
    return '';
  };

  const getName = (): string => {
    if (props.quizStatusDiv == null) {
      return '';
    }
    return getDivLabel('quizStatus', props.quizStatusDiv);
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <span className={`badge badge-common ${getClassSize()} ${getClassColor()}`}>{getName()}</span>
    </>
  );
}
